// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ROOT DECLARATIONS AND 3RD PARTY OVERRIDES - START */
:root {
	--graphileon-color: #027bc4;
	--graphileon-font-family: "Roboto", "Arial", sans-serif;
	--graphileon-font-family-code: monospace;

	/* smart-webcomponents */
    --smart-font-family: var(--graphileon-font-family);
    --smart-font-size: 0.875rem;
    /* bootstrap */
    --bs-body-font-family: var(--graphileon-font-family);
    --bs-font-monospace: var(--graphileon-font-family-code);
    /* jqx widgets */
    --jqx-font-family: var(--graphileon-font-family);
}

html, body {
	font-family: var(--graphileon-font-family);
	background-color: var(--bs-gray-200);
}

/* jqx widgets */
.jqx-widget-bootstrap, .jqx-widget-header-bootstrap, .jqx-fill-state-normal-bootstrap,
.jqx-widget-content-bootstrap, .jqx-fill-state-hover-bootstrap, .jqx-fill-state-pressed-bootstrap {
    font-family: var(--graphileon-font-family);
}
.jqx-widget-content {
    font-family: var(--graphileon-font-family);
    font-size: 0.875rem;
}

/* bootstrap */
.form-control:focus, .form-select:focus, .form-check-input:focus, .was-validated .form-control:valid:focus,
.form-control.is-valid:focus, .was-validated .form-select:valid:focus, .form-select.is-valid:focus,
.was-validated .form-check-input:valid:focus, .form-check-input.is-valid:focus, .was-validated .form-control:invalid:focus,
.form-control.is-invalid:focus, .was-validated .form-select:invalid:focus, .form-select.is-invalid:focus,
.was-validated .form-check-input:invalid:focus, .form-check-input.is-invalid:focus,
.btn:focus-visible, .btn-check:focus-visible + .btn, .btn-check:checked + .btn:focus-visible, :not(.btn-check) + .btn:active:focus-visible,
.btn:first-child:active:focus-visible, .btn.active:focus-visible, .btn.show:focus-visible,
.btn-check:checked:focus-visible + .btn, .nav-link:focus-visible, .navbar-toggler:focus, .page-link:focus,
.btn-close:focus, .toast, .focus-ring:focus {
	box-shadow: none !important;
}


/* ROOT DECLARATIONS AND 3RD PARTY OVERRIDES - END */

/* GRAPHILEON UNIQUE - START */
.graphileon-color {
	color: var(--graphileon-color);
}
.graphileon-bg-color {
	background-color: var(--graphileon-color);
}
.graphileon-border-color {
	border-color: var(--graphileon-color) !important;
}
/* GRAPHILEON UNIQUE - END */

/* FUNCTIONALITY - START */
.dummy {
    /* Dummy wil not be visible, but takes up width to set parent width */
    visibility: hidden;
    height: 1px;
}
.nospace, .dummy-nospace {
    display: none !important;
}

.clickable {
    cursor: pointer;
    cursor: hand;
    -webkit-touch-callout: none;
    -webkit-user-select: none;
    -khtml-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
}
.clickable:hover {
    background-color: var(--bs-gray-400);
}

/* Manipulate display */
.hide {
	display: none;
}
.hidden{
    visibility: hidden;
}
.visible{
    visibility: visible;
}
.inline {
    display: inline-block;
}
.ontop {
	z-index: 1000;
}

/* Spinner when loading the page */
.spinner {
	z-index: 9999;
	position: absolute;
	top: 0;
	left: 50%;
	min-width: 80px;
}
.spinner img {
	position: absolute;
	top: 70px;
	left: 50%;
	width: 80px;
	height: 80px;
	margin:-60px 0 0 -60px;
	-webkit-animation:loader-spin 4s linear infinite;
	-moz-animation:loader-spin 4s linear infinite;
	animation:loader-spin 4s linear infinite;
}
@-moz-keyframes loader-spin { 100% { -moz-transform: rotate(360deg); } }
@-webkit-keyframes loader-spin { 100% { -webkit-transform: rotate(360deg); } }
@keyframes loader-spin { 100% { -webkit-transform: rotate(360deg); transform:rotate(360deg); } }

/* Show/Hide password field input */
.togglePassword {
	font-family: "Font Awesome 5 Free";
	cursor: pointer;
}
.togglePassword:before {
	content: "\\f06e";
}
.togglePassword.show:before {
	content: "\\f070";
}

/* Collapse for sidebars left/right */
.collapsible .when-collapsed {
	display: none;
}
.collapsed .when-collapsed {
	display: inherit;
}
.collapsed .when-not-collapsed {
	display: none;
}

/* Collapse for views */
.collapsable-container.collapsed {
	height: auto!important; /*sized containers have height set with style="" so we need to override that*/
}
.collapsable-container.collapsed .container-body{
	display: none;
}
.collapsable-container .fa.collapse-container-button::before {
	content: "\\f077"; /*font-awsome chevron-up*/
}
.collapsable-container.collapsed .fa.collapse-container-button::before {
	content: "\\f078"; /*font-awsome chevron-down*/
}

/* Dev Cog */
.graphileon-origin-function-button {
	position: absolute;
	top: 0;
	right: 0;
	color: var(--bs-gray-400);
	z-index: 10;
}
.graphileon-origin-function-button:hover {
	cursor: pointer;
	cursor: hand;
	color: var(--bs-black);
}

/* Flex fix for older browser versions*/
.flexbox {
	display: -webkit-box;      /* OLD - iOS 6-, Safari 3.1-6 */
	display: -moz-box;         /* OLD - Firefox 19- (buggy but mostly works) */
	display: -ms-flexbox;      /* TWEENER - IE 10 */
	display: -webkit-flex;     /* NEW - Chrome */
	display: flex;             /* NEW, Spec - Opera 12.1, Firefox 20+ */
}
.flex {
	-webkit-box-flex: 1;      /* OLD - iOS 6-, Safari 3.1-6 */
	-moz-box-flex: 1;         /* OLD - Firefox 19- */
	-webkit-flex: 1;          /* Chrome */
	-ms-flex: 1;              /* IE 10 */
	flex: 1;                  /* NEW, Spec - Opera 12.1, Firefox 20+ */
}
.flex-column {
	-webkit-flex-direction: column; /* Safari 6.1+ */
	flex-direction: column;
}
/* FUNCTIONALITY - END */`, ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
